import type { RetentionItem } from './types';

export const RETENTION_DATA: readonly RetentionItem[] = [
  {
    id: 'raj-patel',
    name: 'Raj Patel',
    riskScore: 72,
    riskLevel: 'high',
    renewal: 'Sep 20, 2026 (7 months)',
    context: 'Raj was an active member for his first 3 months — attended events, engaged in Slack, participated in masterminds. Then silence. No Slack messages in 67 days. Missed last 2 masterminds. No events attended since December. This pattern suggests he stopped getting value, not that he forgot.',
    signals: [
      { text: 'No Slack in 67 days', type: 'negative' },
      { text: 'Missed 2 masterminds', type: 'negative' },
      { text: 'No events since Dec', type: 'negative' },
      { text: 'Was active first 90 days', type: 'positive' },
    ],
  },
  {
    id: 'derek-washington',
    name: 'Derek Washington',
    riskScore: 45,
    riskLevel: 'medium',
    renewal: 'Nov 15, 2026 (9 months)',
    context: 'Derek had a strong start and was consistently engaged through January. Engagement dropped sharply in February — possibly related to app login issues he reported. Worth investigating whether the tech problem is the root cause or just a symptom of deeper disengagement.',
    signals: [
      { text: 'Engagement down 60%', type: 'negative' },
      { text: 'Open support ticket', type: 'negative' },
      { text: 'Strong first 3 months', type: 'positive' },
      { text: 'Attending masterminds', type: 'positive' },
    ],
  },
  {
    id: 'tom-fitzgerald',
    name: 'Tom Fitzgerald',
    riskScore: 40,
    riskLevel: 'medium',
    renewal: 'Aug 12, 2026 (5 months)',
    context: 'Tom attends mastermind sessions consistently but is a ghost in Slack and hasn\'t attended a single in-person event. His engagement is narrow — one channel only. At 58, he may not be a Slack person, but the lack of event attendance for a hospitality founder in Dallas is unusual. His renewal is in 5 months.',
    signals: [
      { text: 'Silent in Slack', type: 'negative' },
      { text: 'No events attended', type: 'negative' },
      { text: 'Attends masterminds', type: 'positive' },
      { text: 'Renewal in 5 months', type: 'negative' },
    ],
  },
  {
    id: 'jeffrey-wazen',
    name: 'Jeffrey Wazen',
    riskScore: 38,
    riskLevel: 'medium',
    renewal: 'Feb 12, 2027 (12 months)',
    context: 'Jeffrey is brand new but flagged because of compounding vulnerability: relocating to a new city without a founder network, revenue declining from $15M to $12M, and his entire reason for joining is connection. If he doesn\'t get meaningful intros in his first 60 days, the risk of quiet disengagement is real.',
    signals: [
      { text: 'New member (11 days)', type: 'positive' },
      { text: 'Completed onboarding', type: 'positive' },
      { text: 'Revenue declining', type: 'negative' },
      { text: 'Relocating — no local network', type: 'negative' },
    ],
  },
  {
    id: 'michael-jamieson',
    name: 'Michael Jamieson',
    riskScore: 28,
    riskLevel: 'low',
    renewal: 'Feb 11, 2027 (12 months)',
    context: 'Michael is deliberate and measured — rated himself 8/10 on interest and wanted to pray on it before joining. His engagement is appropriate for his personality. Main risk is that his previous peer groups went stale. If FC doesn\'t deliver interesting conversations early, he may quietly decide it\'s another stale group.',
    signals: [
      { text: 'Enrolled in mastermind', type: 'positive' },
      { text: 'Survey submitted', type: 'positive' },
      { text: 'NDA missing', type: 'negative' },
      { text: 'No intros made yet', type: 'negative' },
    ],
  },
] as const;
